module.exports = __webpack_public_path__ + "img/1.ab1e4c0b.png";